import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';
import $ from 'jquery';

class HomeSlider {
    constructor(){
        this.slider = jQuery('[data-component="home-slider"]');
        this._init();
    }

    _init(){
        document.addEventListener('DOMContentLoaded', (event) => {
            if(this.slider[0]){
                this.slider.owlCarousel({
                    items:             1,
                    animateOut:        'fadeOut',
                    loop:              true,
                    nav:               true,
                    navText:           ['',''],
                    dots:              false,
                    navContainerClass: 'owl-nav-home',
                    onTranslated:      this.updateNav.bind(this),
                    autoplay:          true,
                    autoplayTimeout:   4000,
                    slideSpeed:        400,
                    autoHeight:        true,
                });
            }
        });
    }
    
    /**
   * Change l'état actif de la navigation du carousel
   * en fonction de l'index de la slide active
   */
  updateNav(event){
    $(this.navItems).attr('data-state', 'inactive');
    $(this.navItems).eq(event.item.index).attr('data-state', 'active');
    if( (event.item.index+1) === event.item.count ) {
      setTimeout( ()=>this.slider.trigger( 'to.owl.carousel', 0 ), 8000 );
    }
  }

  /**
   * Change la slide en fonction de l'index passé en paramètre
   * Change l'état actif de la navigation du carousel en fonction de l'index passé en paramètre
   */
  updateCarousel( index ){
    $(this.navItems).attr('data-state', 'inactive');
    $(this.navItems).eq(index).attr('data-state', 'active');
    this.slider.trigger( 'to.owl.carousel', [index] );
  }
}

export const homeSlider = new HomeSlider();